import { type FieldValues, type UseFormSetError } from 'react-hook-form';

export const setInputErrors = <T extends FieldValues>(
  inputError: {
    errors: { name: string; messagesErrors: string[] }[];
  },
  setError: UseFormSetError<T>
) => {
  const { errors } = inputError;

  errors.forEach(({ name, messagesErrors }) => {
    setError(
      name as T & `root.${string}`,
      {
        type: 'manual',
        message: messagesErrors.join(', '),
      },
      { shouldFocus: true }
    );
  });
};

export const getInputErrors = (inputError: {
  errors: { name: string; messagesErrors: string[] }[];
}) => {
  const { errors } = inputError;
  return errors.reduce(
    (acc, { name, messagesErrors }) => ({
      ...acc,
      [name]: messagesErrors.join(', '),
    }),
    {}
  );
};
